import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/styles.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // Smooth scroll
  const handleScroll = (id) => {
    const el = document.querySelector(id);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 80,
        behavior: "smooth",
      });
    }
    setOpen(false); // close after click
  };

  // FIX: Auto-close menu when screen is resized to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header>
      <div className="container">
        <nav className="navbar">

          {/* Logo */}
          <Link to="/" className="logo">
            Ideas&nbsp;<span id="a">On</span>&nbsp;<span id="b">Work</span>
          </Link>

          {/* Links */}
          <ul className={`nav-links ${open ? "open" : ""}`}>
            <li>
            <a href="#home" onClick={() => handleScroll("#home")}>
              Home
            </a>
          </li>

          <li>
            <a href="#solutions" onClick={() => handleScroll("#solutions")}>
              Solutions
            </a>
          </li>

          <li>
            <a href="#industries" onClick={() => handleScroll("#industries")}>
              Industries
            </a>
          </li>

          <li>
            <a href="#process" onClick={() => handleScroll("#process")}>
              Process
            </a>
          </li>

          <li>
            <a
              href="#contact"
              onClick={() => handleScroll("#contact")}
              className="btn btn-accent"
            >
              Schedule Consultation!
            </a>
          </li>
            {/* <li><a onClick={() => handleScroll("#home")}>Home</a></li>
            <li><a onClick={() => handleScroll("#solutions")}>Solutions</a></li>
            <li><a onClick={() => handleScroll("#industries")}>Industries</a></li>
            <li><a onClick={() => handleScroll("#process")}>Process</a></li>
            <li>
              <a
                onClick={() => handleScroll("#contact")}
                className="btn btn-accent"
              >
                Schedule Consultation!
              </a>
            </li> */}
          </ul>

          {/* Mobile */}
          <div className="mobile-menu" onClick={() => setOpen(!open)}>
            ☰
          </div>
        </nav>
      </div>
    </header>
  );
}
